module.exports = __webpack_public_path__ + "img/contact.19af5887.svg";